import { z } from 'zod';
import { ControllerRenderProps } from 'react-hook-form';

// Schema for edit email form
export const editEmailSchema = z
  .object({
    newEmail: z
      .email('Provide a valid Email Address')
      .min(1, 'New Email is required'),
    confirmNewEmail: z
      .email('Provide a valid Email Address')
      .min(1, 'Confirm New Email is required'),
  })
  .refine((data) => data.newEmail === data.confirmNewEmail, {
    message: 'Emails do not match.',
    path: ['confirmNewEmail'],
  });

export type EditEmailFormData = z.infer<typeof editEmailSchema>;

export type EditEmailFormFieldProps<T extends keyof EditEmailFormData> = {
  field: ControllerRenderProps<EditEmailFormData, T>;
};

// Schema for edit name form
export const editNameSchema = z.object({
  firstName: z.string().min(1, 'Enter a first name'),
  lastName: z.string().min(1, 'Enter a last name'),
});

export type EditNameFormData = z.infer<typeof editNameSchema>;

export type EditNameFormFieldProps<T extends keyof EditNameFormData> = {
  field: ControllerRenderProps<EditNameFormData, T>;
};

// Schema for edit password form
export const editPasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'Current password is required'),
    newPassword: z
      .string()
      .min(12, 'Must be at least 12 characters')
      .regex(/\d/, 'Include at least one number')
      .regex(/[!@#$%^&*(),.?":{}|<>]/, 'Include at least one symbol'),
    confirmNewPassword: z.string().min(1, 'Confirm new password is required'),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: 'Passwords do not match.',
    path: ['confirmNewPassword'],
  });

export type EditPasswordFormData = z.infer<typeof editPasswordSchema>;

export type EditPasswordFormFieldProps<T extends keyof EditPasswordFormData> = {
  field: ControllerRenderProps<EditPasswordFormData, T>;
};

// User profile schema
export interface UserProfile {
  firstName: string;
  lastName: string;
  emailAddress: string;
}

export interface GetUserProfileResponse {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  emailAddress: string;
  phoneNumber?: string;
  roles: string[];
  status: string;
  createdAt: string;
  updatedAt: string;
}
